var variantsData = {};
var selectedVariant = false;

const BIS_Modal = document.querySelector('#BackInStockModal');
const BIS_Form = BIS_Modal.querySelector('form');
const select = BIS_Modal.querySelector('select');
const BISSubmitButton= BIS_Form.querySelector('button');
var userNumber = '';


// Pass on product data to BackInStockModal
document.addEventListener('click', function(e) {
    if (e.target.classList.contains('notify')) {
        const validationChecker = setInterval(function(){
            checkAll()
        }, 100)

        function resetInterval(validationChecker){
            clearInterval(validationChecker)
        }

        document.addEventListener("ModalClose", function(e){
            if(event.detail.id == "BackInStockModal"){
                resetInterval(validationChecker)
            }
        })

        variantsData = JSON.parse(atob(e.target.dataset.variants));
        selectedVariant = e.target.dataset.selected ? e.target.dataset.selected : false;

        BIS_Form.product_id.value = e.target.dataset.product;
        BIS_Form.product_title.value = e.target.dataset.title;
        BIS_Form.variants_data.value = atob(e.target.dataset.variants);
        BIS_Form.variant.innerHTML = '';
        BIS_Form.querySelectorAll(".success, .error").forEach((message) => {
            message.classList.add("hidden");
        });
        if ( variantsData.length == 1 ){
            BIS_Form.querySelector('.variants').classList.add('hidden');
        }else {
            BIS_Form.querySelector('.variants').classList.remove('hidden');
            if(!selectedVariant){
                BIS_Form.variant.innerHTML += '<option disabled selected>Select an Option</option>';
            }
        }
        variantsData.forEach(function(variant){
            BIS_Form.variant.innerHTML += `<option value="${variant.id}" ${selectedVariant && parseInt(selectedVariant) == variant.id ? 'selected' : ''}>${variant.title}</option>`;
        });
        
        document.querySelector('modal-opener[data-modal="#BackInStockModal"] button').click();
    }
});


//Debounce CB function for input field validator
const debounceInput = (callback, wait) => {
    let timeoutId = null;
    return (...args) => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback.apply(null, args);
        }, wait);
    };
}

//Phone Number Validator

const phoneInputField = document.querySelector("#phone_number");
const phoneInput = window.intlTelInput(phoneInputField, {
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js",
    initialCountry: "AU",
    preferredCountries: ["AU", "NZ", "US", "GB"]
});

const infoElement = document.querySelector(".alert-info");
const errorElement = document.querySelector(".alert-error");

// Input field validation

//Phone Number
checkPhoneNumber = debounceInput((ev) => {
    verifyNumber()
}, 500)

function verifyNumber() {
    if (phoneInput.isValidNumber()) {
        verifiedNumber = phoneInput.getNumber()
        userNumber = verifiedNumber.replace("+","")
        isoCountryCode = phoneInput.getSelectedCountryData().iso2
        return true;
    } else {
        return false;
    } 
}


//Check Variant Selected
function variantSelected() {
    if (select.selectedOptions[0].text != "Select an Option") {
        return true;
    } else {
        return false;
    } 
}

//Check Email Address
function emailChecker() {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if(BIS_Form.email.value.match(mailformat)) {
        return true;
    } else {
        return false;
    }
}

//Check all fields
function checkAll(){
    if(emailChecker() && verifyNumber() && variantSelected()){
        BISSubmitButton.removeAttribute("disabled")
        return true;
    } else {
        BIS_Form.querySelector('button').setAttribute('disabled', true)
        return false;
    }
}


//Submit Event
BIS_Form.querySelector('button').addEventListener("click", submitEvent)

async function submitEvent() {
    const selectedVariant = BIS_Form.variant.options[BIS_Form.variant.selectedIndex].value;
    const ProductData = JSON.parse(BIS_Form.variants_data.value);
    const variant = (ProductData.filter((val) => {
        return selectedVariant == val.id
    }))[0]

    const data = {
        phone: userNumber, // Customer phone number
        email: BIS_Form.email.value, // Customer Email
        country: isoCountryCode, // Country ISO Code
        variant: {
            id: variant.id, // Variant ID
            title: variant.title, // Variant Name
            sku: variant.sku, // SKU
        }, product: {
            id: parseInt(BIS_Form.product_id.value), // Product ID
            title: BIS_Form.product_title.value, // Name
        }
    }

    try {
        const submitBIS = await window.smsBumpBackInStock.subscribe(data);
        BIS_Form.querySelector(".success").classList.remove("hidden");
        BISSubmitButton.classList.add("BIS_Success");
        BISSubmitButton.textContent = "Done!";
        document.addEventListener("ModalClose", function(e){
            if(event.detail.id == "BackInStockModal"){
                BISSubmitButton.textContent = "NOTIFY ME";
                BISSubmitButton.classList.remove("BIS_Success");
            }
          })
    } catch (error) {
        console.error(error);
        BIS_Form.querySelector(".error").classList.remove("hidden");
    }
}